import CoachNote from './CoachNote';

export default CoachNote;
